import React from 'react'

const DashboardGlobalStateContext = React.createContext()

export function useDashboardGlobalStateContext() {
  const data = React.useContext(DashboardGlobalStateContext)

  if (data === undefined) {
    throw new Error(
      'useDashboardGlobalStateContext must be used with in DashboardGlobalStateContext'
    )
  }
  return data
}

export default DashboardGlobalStateContext
